import { render, staticRenderFns } from "./amend.vue?vue&type=template&id=aaeb6ae4&scoped=true&"
import script from "./amend.vue?vue&type=script&lang=js&"
export * from "./amend.vue?vue&type=script&lang=js&"
import style0 from "./amend.vue?vue&type=style&index=0&id=aaeb6ae4&lang=scss&scoped=true&"
import style1 from "./amend.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaeb6ae4",
  null
  
)

export default component.exports